import { render, staticRenderFns } from "./registerShop.vue?vue&type=template&id=d2ae500e&scoped=true"
import script from "./registerShop.vue?vue&type=script&lang=js"
export * from "./registerShop.vue?vue&type=script&lang=js"
import style0 from "./registerShop.vue?vue&type=style&index=0&id=d2ae500e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ae500e",
  null
  
)

export default component.exports